<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div class="title-letter" fxLayout="row" fxLayoutGap="10px">
        <mat-icon>edit</mat-icon>
        <span>{{'外部リンクＵＲＬ' | translate}}</span>
      </div>

      <div class="top-buttons" fxLayout="row" fxLayoutGap="10px">
        <button mat-raised-button color="primary" (click)="addCodes()" [disabled]="!codesFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span>{{'更新' | translate}}</span>
        </button>
        
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content fxFlex="600px" style="overflow: auto;">
    <form [formGroup]="codesFormGroup">
      <div fxLayout="column" fxLayoutGap="10px">

        <div *ngIf="!!codesArrayControl" formArrayName="codes" fxFlex="100%">
          <table>
            <tr *ngFor="let codeForm of codesArrayControl.controls; let i=index" [formGroupName]="i">
              <td>
                <p fxFlex="100%">
                  {{ currentLang == 'en' ? (projectLanguages[i].lang_name_en ? projectLanguages[i].lang_name_en : (projectLanguages[i].lang_name | translate)):  projectLanguages[i].lang_name }}
                </p>
              </td>
              <td>
                <mat-form-field fxFlex="100%">
                  <input matInput formControlName="code">
                </mat-form-field>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </form>
  </div>


</div>